export default "__VITE_ASSET__Bbjow5Ru__"